import { Controller } from 'stimulus'

// Segmented Templates|Batteries switch inside the Add-Task modal.
// Tabs carry data-panel="<name>"; panels carry data-panel="<name>" too.
export default class extends Controller {
  static targets = ['panel', 'tab'];

  switch(event) {
    const name = event.currentTarget.dataset.panel

    this.panelTargets.forEach((panel) => {
      panel.classList.toggle('hidden', panel.dataset.panel !== name)
    })

    // .ui-seg-btn segments (the house view toggle), slate when selected.
    this.tabTargets.forEach((tab) => {
      tab.classList.toggle('is-on', tab.dataset.panel === name)
    })
  }
}
